import type { KgFlowNodeType } from "../types";
import { ARTIFACT_TABS } from "./artifactInspectorConfig";
import { DATA_STORY_TABS } from "./dataStoryInspectorConfig";
import type { InspectorTabId } from "./types";

export interface InspectorTabConfig {
  id: InspectorTabId;
  label: string;
}

const DATA_SOURCE_TABS: InspectorTabConfig[] = [
  { id: "overview", label: "Overview" },
  { id: "tables", label: "Tables" },
  { id: "reports", label: "Reports" },
  { id: "usedIn", label: "Used in" },
];

const TABLE_TABS: InspectorTabConfig[] = [
  { id: "overview", label: "Overview" },
  { id: "relationship", label: "Relationship" },
  { id: "metrics", label: "Metrics" },
  { id: "usedIn", label: "Used in" },
];

const ONTOLOGY_TABS: InspectorTabConfig[] = [
  { id: "overview", label: "Overview" },
  { id: "links", label: "Links" },
  { id: "metrics", label: "Metrics" },
  { id: "rules", label: "Rules" },
  { id: "reports", label: "Reports" },
  { id: "usedIn", label: "Used in" },
];

const METRIC_TABS: InspectorTabConfig[] = [
  { id: "overview", label: "Overview" },
  { id: "formula", label: "Formula" },
  { id: "usedIn", label: "Used in" },
];

const DATA_MODEL_TABS: InspectorTabConfig[] = [
  { id: "overview", label: "Overview" },
  { id: "tables", label: "Tables" },
  { id: "metrics", label: "Metrics" },
  { id: "relationships", label: "Relationships" },
];

/** Default report tabs (datasource / retrieved). Native adds Activity via `getInspectorTabsForReport`. */
export const REPORT_TABS: InspectorTabConfig[] = [
  { id: "overview", label: "Overview" },
  { id: "trace", label: "Trace" },
  { id: "usedIn", label: "Used in" },
];

/** Tab sets per node type — extend here when adding new inspector layouts. */
export const INSPECTOR_TABS_BY_NODE_TYPE: Partial<
  Record<KgFlowNodeType, InspectorTabConfig[]>
> = {
  dataSource: DATA_SOURCE_TABS,
  table: TABLE_TABS,
  ontology: ONTOLOGY_TABS,
  metric: METRIC_TABS,
  report: REPORT_TABS,
  dataStory: DATA_STORY_TABS,
  artifact: ARTIFACT_TABS,
  dataModel: DATA_MODEL_TABS,
};

export const getInspectorTabsForType = (
  type: KgFlowNodeType,
): InspectorTabConfig[] =>
  INSPECTOR_TABS_BY_NODE_TYPE[type] ?? [{ id: "overview", label: "Overview" }];
